<button class="btn btn-outline-dark" (click)="openDialog()">
  <i class="bi bi-camera"></i>
</button>
